/**
 * The "escape" key's key code.
 * @type {Number}
 */
export const ESCAPE_KEY_CODE = 27;

/**
 * The "escape" key's key name.
 * @type {String}
 */
export const ESCAPE_KEY_NAME = 'Escape';
